export const formInputLimits = {
  abstract: {
    minLength: 20,
    maxLength: 3000,
  },
  title: {
    maxLength: 512,
  },
  citation: {
    maxLength: 500,
  },
  withdrawalJustification: {
    minLength: 25,
  },
  requestDecisionJustification: {
    minLength: 20,
  },
};
